import React from 'react';
import moment from 'common/moment';

export const TIME_TYPES = {
  DATE: 'DATE',
  TIME: 'TIME',
  DATE_TIME: 'DATE_TIME',
  LONG_LOCALE_DATE: 'LONG_LOCALE_DATE',
};

interface Props {
  type?: string;
  time: string;
  /** IANA zone. When set, `time` is shown in this zone before formatting. */
  timezone?: string;
}

export const Time = ({ type = TIME_TYPES.TIME, time, timezone }: Props) => {
  const m = timezone ? moment(time).tz(timezone) : moment(time);
  let momentTime = '';

  switch (type) {
    case TIME_TYPES.DATE:
      momentTime = m.formatDateDefault();
      break;
    case TIME_TYPES.DATE_TIME:
      momentTime = m.formatFullDateTime();
      break;
    case TIME_TYPES.LONG_LOCALE_DATE:
      momentTime = m.formatLongLocaleDate();
      break;
    case TIME_TYPES.TIME:
    default:
      momentTime = m.formatTimeDefault();
      break;
  }

  return <>{momentTime}</>;
};
